import { render } from "./logdna.vue?vue&type=template&id=5ea460b3"
import script from "./logdna.vue?vue&type=script&lang=js"
export * from "./logdna.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__